import React, { useState, useEffect } from 'react'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useSelector, useDispatch } from "react-redux";
import Button from '@mui/material/Button';
import { Link, useLocation } from "react-router-dom";
import { PostedJobViewAction } from "./../../Redux/action/PostedJobViewAction"
import { FaEye } from 'react-icons/fa';
import { TbArrowBackUpDouble, TbExternalLink } from 'react-icons/tb';
import axios from 'axios';
import Pagination from '../Common/Pagination/Pagination';
import Swal from 'sweetalert2';
import { toast, ToastContainer } from 'react-toastify';
import { CiEdit } from 'react-icons/ci';
import { fetchDesignationDetails } from '../../Redux/action/MasterSkillAction';
import Select from "react-select";

const PostLaterJobs = (props) => {
    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(20);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [selectedDesignation, setSelectedDesignation] = useState([]);
    const [designationSendapi, setDesignationSendAPI] = useState([]);
    const AllDesignationList = useSelector(
        (state) => state?.MasterTableDetails?.designation?.content
    );
    const handleDesignationChange = (selectedOptions) => {
        setSelectedDesignation(selectedOptions);
        const selectedValues = selectedOptions.map((option) => option.value);
        setDesignationSendAPI(selectedValues);
    };
    const userInfo = useSelector((state) => state?.JobView?.result?.jobs);
    const totalPages = useSelector((state) => state?.JobView?.result?.totalPages);
    const location = useLocation();
    const queryParams = new URLSearchParams(location?.search);
    const vId = queryParams.get('vendorId')
    const baseUrl = process.env.REACT_APP_API_PATH;
    const { userResult } = useSelector((state) => state.Auth);
    const id = vId ? vId : userResult?.vendorid;
    const posted = props.posted
    const content = {
        id,
        posted,
        pageNumber,
        search,
        designationSendapi
    }

    let dispatch = useDispatch();
    useEffect(() => {
        dispatch(PostedJobViewAction(content));
        // window.scrollTo(0, 0)
    }, [pageNumber, selectedDesignation]);

    const handleClick = (e) => {
        setcurrentPage(Number(e.target.id));
    };

    const pages = [];
    for (let i = 1; i <= Math.ceil(userInfo?.length / itemsPerPage); i++) {
        pages.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userInfo?.slice(indexOfFirstItem, indexOfLastItem);

    const renderPageNumbers = pages.map((number) => {
        if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
            return (
                <li
                    key={number}
                    id={number}
                    onClick={handleClick}
                    className={currentPage === number ? "active" : null}
                >
                    {number}
                </li>
            );
        } else {
            return null;
        }
    });

    const handleNextbtn = () => {
        setcurrentPage(currentPage + 1);

        if (currentPage + 1 > maxPageNumberLimit) {
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    };

    const handlePrevbtn = () => {
        setcurrentPage(currentPage - 1);

        if ((currentPage - 1) % pageNumberLimit === 0) {
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    };

    let pageIncrementBtn = null;
    if (pages?.length > maxPageNumberLimit) {
        pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
    }

    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
        pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
    }

    const handleDelete = (jobId) => {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `
        .custom-confirm-button {
            background-color: #286a94 !important;
            color: white;
            border-bottom: 1px solid rgb(57, 57, 57);
            
        }
        .custom-title {
            border-bottom: 0.5px solid #adadad;
            text-align:center;
            color: #286a94 !important;
            padding-bottom: 10px;
        }
    `;
        // Append the style to the head of the document
        document.getElementsByTagName('head')[0].appendChild(style);

        const para = document.createElement('div');
        para.className = 'custom-paragraph';
        para.innerText = 'Are you sure you want to delete?';

        Swal.fire({
            title: "Delete Job",
            html: para.outerHTML,
            showCancelButton: true,
            confirmButtonText: "Delete",
            customClass: {
                title: "custom-title",
                confirmButton: "custom-confirm-button" // Add your custom class for the confirm button
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(`${baseUrl}/ebench/delete_jobs?jobId=${jobId}`);
                    dispatch(PostedJobViewAction(content));
                    toast.success('Deleted Successfully');
                    console.log('Delete API Response:', response.data);
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire("Error", "There was an error deleting the job", "error");
                }
            }
        });
    };

    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        dispatch(fetchDesignationDetails());
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const designationOptions = AllDesignationList?.map((item) => ({
        value: item?.designation,
        label: item?.designation,
    }));

    return (
        <div >
            <ToastContainer />
            <div style={{ padding: "10px 20px", borderBottom: "1px solid #d2d7d7", width: '100%' }}>
                <div className={width > 768 ? "form-outline" : ""}>
                    {/* <input
                        className="form-control"
                        type="search"
                        placeholder="Search by Designation"
                        name="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    ></input> */}
                    <div style={{ minWidth: '200px' }}>
                        <Select
                            options={designationOptions}
                            isMulti
                            onChange={handleDesignationChange}
                            placeholder="Select Designation"
                            value={selectedDesignation}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#286a94" : "#ccc",
                                    boxShadow: state.isFocused ? "0 0 0 1px #286a94" : "none",
                                    "&:hover": { borderColor: "#286a94" },
                                    minHeight: "25px",
                                    fontSize: "11px", // affects input text
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    fontSize: "10px",   // dropdown options font size
                                    padding: "6px 8px",
                                    backgroundColor: state.isSelected
                                        ? "#286a94"
                                        : state.isFocused
                                            ? "#e6f2fa"
                                            : "white",
                                    color: state.isSelected ? "white" : "#333",
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e6f2fa",
                                    borderRadius: "8px",
                                    padding: "0px 0px",
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    fontSize: "11px",   // selected tag label font size
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontSize: "11px",   // for single select case
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: "#777",
                                    fontSize: "11px",
                                }),
                            }}
                        />
                    </div>
                </div>
            </div>
            <div>
                <div className="">
                    <div className="card-header common_table_header">
                        Post Later Jobs
                    </div>
                    <div style={{}} className="card-body table-responsive" >
                        <table className="table-data" style={{ width: '100%', textAlign: 'center', fontSize: '14px', overflowX: 'auto', minWidth: location.pathname.includes('admin') ? '65rem' : "" }}>
                            <thead>
                                <tr>
                                    <th className='fw_500' scope="col">Job Id</th>
                                    <th className='fw_500' scope="col">Designation</th>
                                    <th className='fw_500' scope="col">Experience</th>
                                    <th className='fw_500' scope="col">Status</th>
                                    <th className='fw_500' scope="col">Posting Date & Time</th>
                                    <th className='fw_500' scope="col"> Expiry Date </th>
                                    <th className='fw_500' scope="col">Job Details</th>
                                    {(!location.pathname.includes('/admin/posted_jobs') &&
                                        !location.pathname.includes('/admin/job/vendor_jobs')) && (
                                            <th className='fw_500' scope="col">Action</th>
                                        )}
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems && currentItems.map((item, i) => {
                                    return (
                                        <>
                                            <tr key={i} className='postedJob_tr'>
                                                <td>{item.jobUuid}</td>
                                                <td>{item.jobTitle}</td>
<td>
                                            {item.minimumExperience?.includes(
                                              "0"
                                            )
                                              ? `Fresher - ${item.maximumExperience
                                                  ?.replace(/years?/i, "")
                                                  ?.trim()} years`
                                              : `${item.minimumExperience
                                                  ?.replace(/years?/i, "")
                                                  ?.trim()} - ${item.maximumExperience
                                                  ?.replace(/years?/i, "")
                                                  ?.trim()} years`}
                                          </td>                                                <td>
                                                    <div style={{ width: '100px' }} className={`text-start mb-0 ${(item.jobsPostedStatus === 'EXPIRED' || item.jobsPostedStatus === 'DELETED') ? 'red_status' : 'green_status'}`}>
                                                        {item.jobsPostedStatus === 'EXPIRED' ? 'Expired' : item.jobsPostedStatus === 'POSTED' ? 'Posted' : item.jobsPostedStatus === "POSTLATER" ? 'Post Later' : 'Deleted'}
                                                    </div>
                                                </td>
                                                <td>
                                                    {item?.postLaterDate + " " + item?.postLaterTime}
                                                </td>
                                                <td>{item?.validity}</td>
                                                <td><Link to={location.pathname.includes('/admin/posted_jobs')
                                                    ? `/admin/view/job-details?jobId=${item.jobId}`
                                                    : location.pathname.includes('/admin/job/vendor_jobs')
                                                        ? `/admin/job/viewJob?jobId=${item.jobId}` : `/job-details/${item.jobId}`}>
                                                    <TbExternalLink size={24} color='#286a94' />
                                                </Link></td>
                                                {(!location.pathname.includes('/admin/posted_jobs') &&
                                                    !location.pathname.includes('/admin/job/vendor_jobs')) && (
                                                        <td >
                                                            <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
                                                                {/* <Link style={{ cursor: "pointer" }} to={`/edit_Validity_job/${item.jobId}`} >
                                                                    <CiEdit size={24} color='#286a94' />
                                                                </Link> */}
                                                                <div style={{ color: 'red', cursor: "pointer" }} onClick={() => handleDelete(item.jobId)}>
                                                                    <DeleteOutlineIcon />
                                                                </div>
                                                            </div>


                                                        </td>
                                                    )}

                                            </tr>
                                        </>
                                    )
                                })}
                            </tbody>
                        </table>
                        {currentItems?.length === 0 && (
                            <div className="text-center mt-5">
                                <h5>No Data Found</h5>
                            </div>
                        )}
                    </div>
                </div>
                {userInfo?.length >= 1 ? (
                    <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
                ) : (
                    ""
                )}
            </div>
        </div>
    )
}

export default PostLaterJobs;

